module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newTask),
      expression: "newTask"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.newTask)
    },
    on: {
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.addNewTask($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newTask = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": _vm.addNewTask
    }
  }, [_vm._v("Add New Task")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todoList.length),
      expression: "todoList.length "
    }]
  }, [_c('h3', [_vm._v("Todo (" + _vm._s(_vm.todoList.length) + ")")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.todoList), function(task) {
    return _c('li', {
      staticClass: "list-group-item clearfix"
    }, [_c('div', {
      staticClass: "pull-left lead"
    }, [_vm._v("\n          " + _vm._s(task.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          _vm.done(task)
        }
      }
    }, [_vm._v("Done")])])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.doneList.length),
      expression: "doneList.length"
    }]
  }, [_c('h3', [_vm._v("Done (" + _vm._s(_vm.doneList.length) + ")")]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.doneList), function(task) {
    return _c('li', {
      staticClass: "list-group-item clearfix"
    }, [_c('div', {
      staticClass: "pull-left lead"
    }, [_vm._v("\n          " + _vm._s(task.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticClass: "pull-right"
    }, [_c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.undone(task)
        }
      }
    }, [_vm._v("Undone")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-default",
      on: {
        "click": function($event) {
          _vm.remove(task)
        }
      }
    }, [_vm._v("Remove")])])])
  }))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.todoList.length || _vm.doneList.length),
      expression: "todoList.length || doneList.length"
    }],
    staticClass: "btn btn-default",
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("\n    Clear all\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1600427c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Lesson3/Index.vue
// module id = 25
// module chunks = 0